import { Button, DialogActions } from "@mui/material"
import { useDialog } from "../../libs/dialog/DialogProvider"

export interface IConfirmProps {
    message:string
    onConfirm:() => void
}
export default function Confirm(props:IConfirmProps){
    const {closeDialog} = useDialog()
    const onConfirm = () => {
        closeDialog()
        props.onConfirm()
    }
    return <>
        <div className="content">
            <p>{props.message}</p>
        </div>
        <DialogActions>
            <Button variant="outlined" onClick={closeDialog}>Cancel</Button>
            <Button variant="contained" onClick={onConfirm}>Okay</Button>
        </DialogActions>
    </>
}